module.exports = __webpack_public_path__ + "assets/img/Australian-Seniors-Landing-Page-w540.a940339d.webp";